import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { SupportSource } from '../../api/support/types';

interface SupportSourcesProps {
    sources: SupportSource[] | null;
    /** Bordure de séparation au-dessus de la liste (couleur selon le fond du message). */
    className?: string;
    /** Équipe TriggerFlow seulement : ajoute le titre de la fiche interne après le libellé. */
    showInternalTitle?: boolean;
}

/**
 * Sources citées par l'IA : article d'aide en lien, donnée consultée en libellé, fiche du manuel interne
 * en libellé « Documentation TriggerFlow » sans lien. Rien si aucune source.
 */
export default function SupportSources({ sources, className = 'mt-2 space-y-1 text-xs', showInternalTitle = false }: SupportSourcesProps) {
    const { t } = useTranslation('support');
    if (!sources || sources.length === 0) return null;

    return (
        <ul className={className}>
            <li className="font-medium">{t('sources')}</li>
            {sources.map((source) => (
                <li key={`${source.type}:${source.ref}`}>
                    {source.internal ? (
                        <span>
                            {showInternalTitle && source.title
                                ? t('source_internal_doc_titled', { title: source.title })
                                : t('source_internal_doc')}
                        </span>
                    ) : source.type === 'article' && source.url ? (
                        <Link to={source.url} className="text-primary-color underline">{source.title ?? source.ref}</Link>
                    ) : (
                        <span>{source.type === 'data' ? t('source_data') : (source.title ?? source.ref)}</span>
                    )}
                </li>
            ))}
        </ul>
    );
}
